import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import "@/styles/uxPolish.css";
import "@/styles/smoothness.css";
import App from "@/App";
import EmployeeFormPage from "@/pages/EmployeeFormPage";
import PublicRecruitmentForm from "@/components/public/PublicRecruitmentForm";
import HostessGuestCounterPage from "@/pages/HostessGuestCounterPage";
import PublicEventForm from "@/pages/PublicEventForm";
import PublicDeliverySurvey from "@/pages/PublicDeliverySurvey";
import PublicRestaurantSurvey from "@/pages/PublicRestaurantSurvey";
import ClubApp from "@/pages/club/ClubApp";
import PublicInfoPage from "@/pages/PublicInfoPage";
import ProtocolPhotoUpload from "@/pages/ProtocolPhotoUpload";
import PublicDeliveryComplaint from "@/pages/PublicDeliveryComplaint";
import LegalDocumentPage from "@/components/legal/LegalDocumentPage";
import CookieBanner from "@/components/legal/CookieBanner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/formularz-pracownika" element={<EmployeeFormPage />} />
        <Route path="/employee-form" element={<EmployeeFormPage />} />
        <Route path="/rekrutacja" element={<PublicRecruitmentForm />} />
        <Route path="/hostess/:location" element={<HostessGuestCounterPage />} />
        <Route path="/event/:token" element={<PublicEventForm />} />
        <Route path="/dostawa/:location" element={<PublicDeliverySurvey />} />
        <Route path="/restauracja/:location" element={<PublicRestaurantSurvey />} />
        <Route path="/mrjerryclub/*" element={<ClubApp />} />
        <Route path="/info/:id" element={<PublicInfoPage />} />
        <Route path="/protocol-photo/:handoffId" element={<ProtocolPhotoUpload />} />
        <Route path="/reklamacja/:location" element={<PublicDeliveryComplaint />} />
        <Route path="/reklamacja" element={<PublicDeliveryComplaint />} />
        <Route path="/regulamin" element={<LegalDocumentPage docType="regulamin" />} />
        <Route path="/regulamin-reklamacji" element={<LegalDocumentPage docType="complaints" />} />
        <Route path="/regulamin-konkursu" element={<LegalDocumentPage docType="contest" />} />
        <Route path="/polityka-prywatnosci" element={<LegalDocumentPage docType="privacy" />} />
        <Route path="/polityka-cookies" element={<LegalDocumentPage docType="cookies" />} />
        <Route path="/*" element={<App />} />
      </Routes>
      <CookieBanner />
    </BrowserRouter>
  </React.StrictMode>,
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { updateViaCache: 'none' })
      .then((registration) => {
        console.log('✅ PWA: Service Worker registered successfully:', registration.scope);

        // Check for updates every time tab becomes visible
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch(() => {});
          }
        });

        // When a new SW takes control, reload once to pick up new assets
        let reloaded = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (reloaded) return;
          reloaded = true;
          console.log('🔄 PWA: New version detected, reloading...');
          window.location.reload();
        });
      })
      .catch((error) => {
        console.log('❌ PWA: Service Worker registration failed:', error);
      });
  });
}
